import { render, staticRenderFns } from "./ciic-form-edit.vue?vue&type=template&id=75298489&scoped=true&"
import script from "./ciic-form-edit.vue?vue&type=script&lang=js&"
export * from "./ciic-form-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75298489",
  null
  
)

export default component.exports